import React, { useState, useEffect } from 'react';
import styles from '../../App.module.css';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import api from '../../api/axios';
import { isAuthenticated, permissionConfig } from '../../index';

function Signin() {

  const [userEmail, setUserEmail] = useState("");
  const [userSenha, setUserSenha] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  async function handleSignin() {
    if (!userEmail || !userSenha) {
      setError("Preencha todos os campos");
      return;
    }
    try {
      setIsLoading(true);
      setError("");
      // NotificationManager.info("Verificando credenciais...", "Aguarde", 2000);
      const res = await api.post('/validarLogin', {
        userLogin: userEmail,
        userSenha: userSenha,
      });
      if (res.data?.token) {
        localStorage.setItem('authToken', res.data.token);
        try {
          console.log("Avisando a extensão sobre o novo token de autenticação...");
          window.postMessage({
            __GSCRM_AUTH__: true,
            type: "PAGE_TO_EXT_SAVE_TOKEN",
            token: res.data.token,
            // se quiser enviar como "authTokens" multi-empresas:
            // authTokens: { [window.location.origin + "/validarLogin"]: res.data.token }
          }, "*");
        } catch (e) {
          console.warn("Não foi possível avisar a extensão:", e);
        }
        const { userPermission } = isAuthenticated();
        const permission = userPermission || 0;
        const firstPath = permissionConfig[permission][0];
        window.location.href = firstPath;
      } else {
        setError("Login ou senha incorretos");
        NotificationManager.error("Login ou senha incorretos");
      }
    } catch (err) {
      console.error('Erro ao tentar fazer login:', err);
      setError("Erro ao tentar fazer login. erro na requisição de validação do Login, entre em contato com o programador");
      NotificationManager.error("Falha na conexão ou no servidor");
    } finally {
      setIsLoading(false);
    }
  }

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 800);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 800);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);



  return (
    <div>
      <NotificationContainer />

      <div
        style={{
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          minHeight: "100vh",
          width: "100%",
        }}
      >

        {/* LADO DO LOGIN */}
        <div
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "20px",
          }}
        >
          <div
            style={{
              width: "100%",
              maxWidth: "400px",
            }}
          >
            {isLoading && <div className={styles.topProgress} />}

            <div className={styles.label}>
              <h1>LOGIN</h1>
              <p>Insira o seu email e senha para continuar</p>
            </div>

            <div className={styles.content}>
              <input
                className={styles.input}
                type="email"
                placeholder="Digite seu E-mail"
                value={userEmail}
                onChange={(e) => {
                  setUserEmail(e.target.value);
                  setError("");
                }}
                disabled={isLoading}
              />

              <input
                className={styles.input}
                type="password"
                placeholder="Digite sua Senha"
                value={userSenha}
                onChange={(e) => {
                  setUserSenha(e.target.value);
                  setError("");
                }}
                disabled={isLoading}
              />

              <div className={styles.labelError}>{error}</div>

              <button
                className={styles.button}
                onClick={handleSignin}
                disabled={isLoading}
              >
                {isLoading ? "Verificando..." : "Entrar"}
              </button>

              <div className={styles.labelsignup}>
                Não tem uma conta?
                <a href="/signup"> Registre-se</a>
              </div>
            </div>
          </div>
        </div>


      </div>
    </div>
  );





}

export default Signin;
